import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { IExpense } from '../interface/expense';

interface IGetExpenseById {
  id?: string;
  relations?: string[];
  fields?: string[];
}
export const useGetExpenseById = (params: IGetExpenseById) => {
  const { id, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const expenseUrl = `${API_URLS.EXPENSES}/${id}`;
  const url = queryString ? `${expenseUrl}?${queryString}` : expenseUrl;
  const query = useQuery<IExpense, Error>({
    queryKey: ['expense-details', id],
    queryFn: async () => {
      const response = await get(url);
      return response;
    },
    enabled: !!id,
  });

  return query;
};
